import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNavigationSettings } from '../../hooks/useNavigationSettings';
import { useAuth } from '../../contexts/AuthContext';
import PageDisabled from '../../pages/Error/PageDisabled';

const RouteGuard = ({ children, requiredPage, requiredRole = null }) => {
  const { data: navigationSettings, isLoading } = useNavigationSettings();
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  // Si les paramètres de navigation sont en cours de chargement, afficher un loader
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Si la page est désactivée dans les paramètres de navigation
  if (requiredPage && navigationSettings && navigationSettings[requiredPage] === false) {
    const pageNames = {
      'projects': 'La page Projets',
      'users': 'La page Utilisateurs',
      'callForProjects': 'La page Appels à Projets',
      'subscriptions': 'La page Abonnements',
      'dashboard': 'Le Tableau de Bord',
      'myProjects': 'La page Mes Projets',
      'myApplications': 'La page Mes Candidatures',
      'favorites': 'La page Favoris',
      'messaging': 'La page Messagerie',
      'matching': 'La page Matching',
      'profile': 'La page Profil',
      'admin': 'La page Administration',
      'superAdmin': 'La page Super Admin',
      'contacts': 'La page Contacts',
      'payment': 'La page Paiement'
    };
    
    return <PageDisabled pageName={pageNames[requiredPage] || "Cette page"} />;
  }

  // Vérification des rôles si nécessaire
  if (requiredRole && (!isAuthenticated || user?.role !== requiredRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Vérification de l'authentification pour les pages protégées
  if (requiredPage && !isAuthenticated) {
    // Rediriger vers la page de connexion avec le retour
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // Si tout est OK, afficher le composant
  return children;
};

export default RouteGuard;
